import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { TokenService } from '../services/token.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ToastUtil } from '../../utils/toast.util';

export const permissionGuard: CanActivateFn = (route) => {
    const tokenService = inject(TokenService);
    const router = inject(Router);
    const messageService = inject(MessageService);
    const translate = inject(TranslateService);

    const requiredPermission = route.data['requiredPermission'] as string;
    const hasPermission = tokenService.hasPermission(requiredPermission);

    console.log(`[PermissionGuard] Required: ${requiredPermission}, Has it: ${hasPermission}`);

    if (hasPermission) {
        return true;
    }

    // Robustness: check both singular and plural for modules
    if (requiredPermission.startsWith('module:')) {
        const isPlural = requiredPermission.endsWith('s');
        const alternative = isPlural
            ? requiredPermission.slice(0, -1)
            : requiredPermission + 's';

        if (tokenService.hasPermission(alternative)) {
            console.log(`[PermissionGuard] Accepted alternative: ${alternative}`);
            return true;
        }
    }

    // Show error message and redirect
    translate.get('app.errors.unauthorizedModule').subscribe(msg => {
        ToastUtil.showError(messageService, msg);
    });

    router.navigate(['/equipos']);
    return false;
};
